import { useState } from "react";
import { toast } from "sonner";
import { Send, Loader2, CheckCircle2 } from "lucide-react";
import { subscribeNewsletter } from "@/lib/api";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    setState("sending");
    try {
      await subscribeNewsletter(email);
      setState("done");
      toast.success("You're subscribed — welcome!");
    } catch {
      setState("idle");
      toast.error("Could not subscribe right now. Please try again.");
    }
  };

  if (state === "done") {
    return (
      <p data-testid="newsletter-success" className="flex items-center gap-2 text-sm font-medium text-forest dark:text-sage">
        <CheckCircle2 className="h-4 w-4" /> You're on the list. Thank you!
      </p>
    );
  }

  return (
    <form onSubmit={onSubmit} data-testid="newsletter-form" className="flex w-full max-w-md gap-2">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        aria-label="Email address for newsletter"
        data-testid="newsletter-email-input"
        className="h-11 flex-1 rounded-full border border-input bg-background px-5 text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
      />
      <button
        type="submit"
        disabled={state === "sending"}
        data-testid="newsletter-submit-button"
        className="inline-flex h-11 items-center gap-2 rounded-full bg-forest px-5 text-sm font-medium text-cream transition-colors duration-300 hover:bg-terracotta-500 disabled:opacity-60 dark:bg-terracotta-500 dark:hover:bg-terracotta-400"
      >
        {state === "sending" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        Subscribe
      </button>
    </form>
  );
}
